import { createFileRoute, useSearch, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { TransferForm } from "@/features/transfers/TransferForm";
import { canCreateTransfer } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/transfers/new")({
  validateSearch: z.object({ assetId: z.string().optional() }),
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateTransfer(me.roles)) throw redirect({ to: "/transfers" });
  },
  component: NewTransferPage,
});

function NewTransferPage() {
  const search = useSearch({ from: "/_authenticated/transfers/new" });
  return <TransferForm presetAssetId={search.assetId} />;
}
